import { useDensity } from '../../../contexts/DensityContext';

export function useCapacityInputClass() {
  const compact = useDensity();
  return `w-full ${compact ? 'px-2 py-1 text-xs' : 'px-4 py-2.5 text-sm'} rounded-lg border border-gray-300 bg-panel text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all dark:border-gray-600 dark:text-gray-100 dark:placeholder:text-gray-500 disabled:opacity-50 disabled:cursor-not-allowed`;
}
